import Echo from 'laravel-echo';
import auth from '@general/lib/auth';

import newMessageReceivedListener from '@chat/lib/listeners/newMessageReceivedListener'
import newEventMessageReceivedListener from '@chat/lib/listeners/newEventMessageReceivedListener'
import updateMessageSentListener from '@chat/lib/listeners/updateMessageSentListener'
import updateMessageReceivedListener from '@chat/lib/listeners/updateMessageReceivedListener'
import CheckMessageListener from "@chat/lib/listeners/CheckMessageListener";
import UserBlockedListener from "@chat/lib/listeners/UserBlockedListener";
import newMessageTypingListener from '@chat/lib/listeners/newMessageTypingListener';
import newMessageEmojiListener from '@chat/lib/listeners/newMessageEmojiListener';

import newNotificationReceivedListener from '@notifications/lib/listeners/newNotificationReceivedListener'
import newVisitorReceivedListener from '@notifications/lib/listeners/newVisitorReceivedListener'
import eventMembershipUpdated from '@events/lib/listeners/eventMembershipUpdateListener'
import eventMembershipInvite from '@events/lib/listeners/eventMembershipInviteListener'

import updateUserListener from './listeners/updateUserListener'
import userEventListener from './listeners/userEventListener'
import videoProcessedListener from './listeners/videoProcessedListener'
import refreshDataRequestListener from './listeners/refreshDataRequestListener'
import forceReload from './listeners/forceReload'
import showErrorNotificationListener from './listeners/showErrorNotificationListener'
import userSuspendedListener from './listeners/userSuspendedListener'

import eventsModule from '@events/module/store/type';
import clubsModule from '@events/module/store/type';
import videoDownloadPercentageListener from "./listeners/videoDownloadPercentageListener";

(function createEchoInstance() {
    let token = 'not_defined_yet';
    console.log('[Echo] createEchoInstance')

    if(window.BROADCAST_DRIVER === 'redis'){
        if (
            typeof io !== 'undefined'
            &&
            typeof window.Echo == 'undefined'
        ) {
            window.Echo = new Echo({
                broadcaster: 'socket.io',
                host: window.CHAT_DOMAIN + ':' + window.NODEJS_PORT,
                auth: {headers: {Authorization: 'Bearer ' + token}}
            });

            window.Echo.connector.socket.on('connect', function(){
                console.log('[Echo] connected', window.Echo.socketId());
                store.commit('setSocketStatus','connected')
            });
            window.Echo.connector.socket.on('disconnect', function(){
                console.log('[Echo] disconnected');
                store.commit('setSocketStatus','disconnected')
            });
        }
    }else{
        window.Pusher = require('pusher-js');
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: window.PUSHER_APP_KEY,
            wsHost: window.CHAT_DOMAIN,
            wssHost: window.CHAT_DOMAIN,
            encrypted: true,
            authEndpoint:  'https://'+ window.WEBSOCKET_AUTHORIZATION_DOMAIN +'/broadcasting/auth',
            //wsPort: window.NODEJS_PORT,
            //wssPort: window.NODEJS_PORT,
            forceTLS: false,
            disableStats: true,
            cluster:"mt1",
            enabledTransports: ['ws', 'wss']
        });
        let websocket_reload_interval = null;
        window.Echo.connector.pusher.connection.bind('state_change', function (states) {
            console.log('[Pusher state_change]',states);
            if(websocket_reload_interval){
                console.log('[Pusher clear reload interval]',states);
                clearTimeout(websocket_reload_interval);
            }
            if (states.current !== 'connected') {
                console.log('[Pusher] disconnected');
                store.commit('setSocketStatus','disconnected')
                websocket_reload_interval = setTimeout(function(){
                    let socketsatus = store.getters.getSocketStatus;
                    console.log('Socket status: ',socketsatus);
                    if(socketsatus === 'disconnected'){
                        console.log('[Pusher] RELOAD PAGE')
                        //window.location.reload();
                    }
                }, 60000);
            }else{
                console.log('[Pusher] connected');
                store.commit('setSocketStatus','connected')
            }
        });
    }
})();

export const initEchoListeners = () => {
    console.log('[Echo] initEchoListeners')

    if(!auth.isAuthenticated()) {
        console.log("[Echo] Can't listen because I'm unauthenticated");
        return;
    }

    if(typeof window.Echo == 'undefined') {
        console.log("[Echo] Can't listen because Echo is not defined");
        return;
    }

    let userId = auth.getUserId();
    let token = auth.getToken();

    window.Echo.connector.options.auth.headers.Authorization = 'Bearer ' + token;

    console.log('[Echo] Listening to channel-' + userId);
    window.Echo
        .private('channel-' + userId)
        .listen('UpdateMessageSent', updateMessageSentListener)
        .listen('UpdateMessageReceived', updateMessageReceivedListener)
        .listen('NewMessageReceived', newMessageReceivedListener)
        .listen('NewEventMessageReceived', newEventMessageReceivedListener)
        .listen('NewNotificationReceived', newNotificationReceivedListener)
        .listen('UserEvent', userEventListener)
        .listen('UserSuspended', userSuspendedListener)
        .listen('VideoProcessed', videoProcessedListener)
        .listen('VideoDownloadPercentage', videoDownloadPercentageListener)
        .listen('ShowErrorNotification', showErrorNotificationListener)
        .listen('NewVisitorReceived', newVisitorReceivedListener)
        .listen('RefreshDataRequest', refreshDataRequestListener)
        .listen('NewMessageTyping', newMessageTypingListener)
        .listen('EmojiEvent',newMessageEmojiListener)
        .listen('ForceReload', forceReload)
        .listen('EventMembershipUpdated', eventMembershipUpdated)
        .listen('EventMembershipInvite', eventMembershipInvite)
        .listen('CheckMessage', CheckMessageListener)
        .listen('UserBlocked', UserBlockedListener)
        .listen('UpdateUser', updateUserListener)

    console.log('[Echo] Listening to channel-event-membership');
    window.Echo
        .private('channel-event-membership')
        .listen('EventMembershipUpdated', eventMembershipUpdated)
};

export const stopListeningForMessages = () => {
    if(typeof window.Echo == 'undefined') {
        console.log("[Echo] Can't stop listening because Echo is not defined");
        return;
    }

    let userId = auth.getUserId();

    window.Echo.leave('channel-'+userId);
    console.log('[Echo] Leaved channel'+userId);

    window.Echo.leave('channel-event-membership');
    console.log('[Echo] Leaved channel channel-event-membership');

    store.dispatch(eventsModule.actions.membership.unsubscribeFromAll)
    store.dispatch(clubsModule.actions.membership.unsubscribeFromAll)
};
